// extracted by mini-css-extract-plugin
module.exports = {"image-focus-point-crosshair":"focus-point_image-focus-point-crosshair__22jB9"};